module.exports = __webpack_public_path__ + "static/img/felos.3731008.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/felos.jpg
// module id = JU2d
// module chunks = 0